export function section04(windowHeight) {
    // let section4 = document.querySelector('.section#section-4');
    // let pinAmount_section4 = section4.outerHeight * 7;
    let pinAmount_section4 = windowHeight * 7

    var namingTL = gsap.timeline({
        scrollTrigger: {
            trigger: ".section#section-4",
            start: "top top",
            end: () => `+=${pinAmount_section4}`,
            scrub: 1,
            pin: ".section#section-4",
            // onToggle: function(){
            // $('.pin-wrapper#section-4').css({'min-height':pinAmount_section4})
            // ScrollTrigger.refresh();
            // },
        },
    })

    namingTL
        //start of stage 1 intro text
        .to(".section#section-4 .stage#stage-1", {
            opacity: 0,
            ease: "power2.inOut",
        })

        //start of stage 2 logo
        .to(".section#section-4 .stage#stage-2", {
            opacity: 1,
            ease: "power2.inOut",
        })
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-2",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        //hiding wordmark
        .to(".section#section-4 .stage#stage-2 svg#wordmark", {
            delay: 0.5,
            opacity: 0,
            ease: "power2.inOut",
        })
        //focusing on motif
        .to(".section#section-4 .stage#stage-2 svg#motif", {
            // 'padding-left' : '5%',
            top: "50%",
            left: "50%",
            x: "-50%",
            y: "-50%",
            scale: 2.5,
            ease: "expo.out",
        })
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-3",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        //hiding all other morif elements apart from HEART
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#arrow",
            {
                opacity: 0,
                ease: "power2.inOut",
            },
            ">+=0.25"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#roof",
            {
                opacity: 0,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif rect#diamond",
            {
                opacity: 0,
                ease: "power2.inOut",
            },
            "<"
        )
        //HEART description
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#heart",
            {
                y: "25%",
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#heart",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-4",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#heart .motif-title",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#heart .motif-content",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        //HEART exit
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#heart",
            {
                y: "50%",
                opacity: 0,
                ease: "power2.inOut",
            },
            ">+1"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#heart",
            {
                y: 30,
                opacity: 0,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        //ARROW description
        .to(
            ".section#section-4 .stage#stage-2 .full-logo",
            {
                duration: 0,
                top: "42%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif",
            {
                duration: 0,
                left: "60%",
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#arrow",
            {
                opacity: 1,
                x: "25%",
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-5",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#arrow",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#arrow .motif-title",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#arrow .motif-content",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        //ARROW exit
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#arrow",
            {
                x: "50%",
                opacity: 0,
                ease: "power2.inOut",
            },
            ">+1"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#arrow",
            {
                y: 30,
                opacity: 0,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        //ROOF description
        .to(
            ".section#section-4 .stage#stage-2 svg#motif",
            {
                duration: 0,
                opacity: 0,
                left: "50%",
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator",
            {
                opacity: 0.25,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-6",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#roof",
            {
                opacity: 1,
                y: "-30%",
                ease: "power2.inOut",
            },
            "<"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#roof",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#roof .motif-title",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            "<"
        )
        .from(
            ".section#section-4 .stage#stage-2 .motif-desc#roof .motif-content",
            {
                opacity: 0,
                y: 30,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        //ROOF exit
        .to(
            ".section#section-4 .stage#stage-2 svg#motif g#roof",
            {
                y: "-50%",
                opacity: 0,
                ease: "power2.inOut",
            },
            ">+1"
        )
        .to(
            ".section#section-4 .stage#stage-2 .motif-desc#roof",
            {
                y: 30,
                opacity: 0,
                ease: "power2.inOut",
            },
            ">-0.25"
        )

        .to(
            ".section#section-4 .stage#stage-3",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            ">-0.25"
        )
        .to(".section#section-4 .stage-indicator-wrapper .stage-indicator", {
            opacity: 0.25,
            ease: "power2.inOut",
        })
        .to(
            ".section#section-4 .stage-indicator-wrapper .stage-indicator#indicator-7",
            {
                opacity: 1,
                ease: "power2.inOut",
            },
            "<"
        )
}
